import React from 'react';
import { Link } from 'react-router-dom';
import { newsSection } from '../../data/homepage';
import { CategoryTag } from '../ui/CategoryTag';
import { PillButton } from '../ui/PillButton';

/**
 * « Quoi de neuf? » : photo aérienne en fond, carte blanche posée par-dessus.
 *
 * Le chevauchement n'est PAS fait en marge négative : dès qu'un titre passe sur deux
 * lignes, le dépassement cesse d'être symétrique. Les deux enfants occupent la même
 * cellule de grille, la photo en `h-full` et la carte avec sa propre marge verticale —
 * la photo grandit donc avec la carte.
 */
export function NewsSpotlight() {
  return <section aria-labelledby="quoi-de-neuf" className="grid w-full" data-id="element-1793" data-mp="21yzhwkxfnnqp">
      <img src={newsSection.background} alt="" className="col-start-1 row-start-1 h-full w-full object-cover" data-id="element-1794" data-mp="26xkfsdp7pvbz" />

      <div className="col-start-1 row-start-1 mx-auto w-full max-w-[1400px] px-5 py-10 md:py-16 lg:px-10" data-id="element-1795" data-mp="2bxozsdpbx86y">
        <div className="grid gap-8 bg-white p-7 md:grid-cols-[minmax(0,260px)_minmax(0,1fr)] md:gap-10 lg:p-10" data-id="element-1796" data-mp="2gvgq53absm91">
          <div data-id="element-1797" data-mp="mk2lt6qb0nrl">
            <h2 id="quoi-de-neuf" className="font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tight text-ville-navy lg:text-4xl" data-id="element-1798" data-mp="hn2d0o22l6ws">
              {newsSection.title}
            </h2>
            <PillButton to={newsSection.cta.to} variant="orange" className="mt-6" data-id="element-1799" data-mp="8npcwlzu5uoq">
              {newsSection.cta.label}
            </PillButton>
          </div>

          <ul className="grid gap-6 divide-y divide-slate-200 md:grid-cols-2 md:gap-8 md:divide-y-0 md:divide-x" data-id="element-1800" data-mp="10dtvcf41c7nb">
            {newsSection.items.map(item => <li key={item.id} className="pt-6 first:pt-0 md:px-6 md:pt-0 md:first:pl-0" data-id="element-1801" data-mp="vl0mbf1jad5f">
                <div className="flex flex-wrap items-center gap-3" data-id="element-1802" data-mp="rl0038870xnt">
                  <CategoryTag label={item.category} data-id="element-1803" data-mp="1o469w8tsd2mv" />
                  <span className="text-sm text-slate-500" data-id="element-1804" data-mp="1o4z5qer7i7q8">{item.date}</span>
                </div>
                <h3 className="mt-3 text-xl font-bold leading-snug text-ville-navy" data-id="element-1805" data-mp="1jal805p2noie">{item.title}</h3>
                <Link to={item.to} className="mt-4 inline-block text-xs font-bold uppercase tracking-wider text-ville-navy underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-blue focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1806" data-mp="3dmmfn36p1ozs">
                  Lire la suite
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}